<template>
  <div class="tw-relative tw-mb-[24px]">
    <div
      v-if="disabled"
      class="tw-absolute tw-left-0 tw-top-0 tw-z-10 tw-h-full tw-w-full tw-bg-white/75"
    ></div>
    <div class="tw-my-[24px] tw-flex tw-items-center tw-justify-between">
      <span
        class="tw-text-[16px] tw-font-semibold tw-leading-none tw-text-primary-grey"
      >
        Rooms
      </span>

      <button
        type="button"
        class="tw-rounded-[4px] tw-p-1 tw-text-[14px] tw-font-semibold tw-leading-[21px] tw-text-uhblue-500 tw-underline tw-decoration-uhblue-500 tw-decoration-solid hover:tw-bg-[#F3F4F6] focus-visible:tw-ring focus-visible:tw-ring-sky-200 focus-visible:tw-ring-opacity-50 disabled:tw-bg-white disabled:tw-text-gray-400 disabled:tw-decoration-gray-400"
        aria-label="Clear bedroom and bathroom filters"
        :disabled="isClearDisabled"
        @click.prevent="clearValues"
      >
        Clear
      </button>
    </div>

    <div class="tw-flex tw-h-[40px] tw-items-center tw-justify-between">
      <span
        class="tw-text-[16px] tw-font-normal tw-leading-[24px] tw-text-[#3B4143]"
      >
        Bedrooms
      </span>

      <UhNumberStepperRound
        :existing-value="localSelectedBedrooms"
        :max="15"
        :mobile-width="true"
        class="tw-max-h-[40px] tw-leading-none"
        default-value="Any"
        test-id="mobile-stacked-filters-bedrooms"
        @update="handleBedroomChange"
      />
    </div>

    <div
      class="tw-mt-[16px] tw-flex tw-h-[40px] tw-items-center tw-justify-between"
    >
      <span
        class="tw-text-[16px] tw-font-normal tw-leading-[24px] tw-text-[#3B4143]"
      >
        Bathrooms
      </span>

      <UhNumberStepperRound
        :existing-value="localSelectedBathrooms"
        :max="maxBedroomCount"
        :mobile-width="true"
        class="tw-max-h-[40px] tw-leading-none"
        :display-symbol="displaySymbol"
        default-value="Any"
        test-id="mobile-stacked-filters-bathrooms"
        @update="handleBathroomChange"
      />
    </div>
  </div>
</template>

<script>
import UhNumberStepperRound from '@components/Shared/Inputs/UhNumberStepperRound.vue';

export default {
  name: 'StackedRoomsFilter',
  components: { UhNumberStepperRound },
  props: {
    selectedBedrooms: {
      type: [Number, String],
      default: 0,
    },
    selectedBathrooms: {
      type: [Number, String],
      default: 0,
    },
    useExactRoomCounts: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSelectedBedrooms: 0,
      localSelectedBathrooms: 0,
    };
  },
  computed: {
    isClearDisabled() {
      return (
        this.localSelectedBedrooms === 0 && this.localSelectedBathrooms === 0
      );
    },
    displaySymbol() {
      if (this.useExactRoomCounts) {
        return '';
      }

      return '+';
    },
    maxBedroomCount() {
      if (this.useExactRoomCounts || !this.selectedBedrooms) {
        return;
      }

      return this.selectedBedrooms;
    },
  },
  watch: {
    selectedBedrooms: {
      handler(newVal) {
        if (newVal === '10-plus') {
          this.localSelectedBedrooms = 10;
          return;
        }

        if (!newVal) {
          this.localSelectedBedrooms = 0;
          return;
        }

        this.localSelectedBedrooms = parseInt(newVal) ?? 0;
      },
      immediate: true,
    },
    selectedBathrooms: {
      handler(newVal) {
        if (newVal === '10-plus') {
          this.localSelectedBathrooms = 10;
          return;
        }

        if (!newVal) {
          this.localSelectedBathrooms = 0;
          return;
        }

        this.localSelectedBathrooms = parseInt(newVal) ?? 0;
      },
      immediate: true,
    },
  },
  methods: {
    handleBedroomChange(newValue) {
      if (!this.useExactRoomCounts && this.selectedBathrooms > newValue) {
        this.handleBathroomChange(newValue);
      }

      this.localSelectedBedrooms = newValue ?? 0;
      this.$emit('set-current-bedrooms', this.localSelectedBedrooms || null);
    },
    handleBathroomChange(newValue) {
      this.localSelectedBathrooms = newValue ?? 0;
      this.$emit('set-current-bathrooms', this.localSelectedBathrooms || null);
    },
    clearValues() {
      this.localSelectedBedrooms = 0;
      this.localSelectedBathrooms = 0;

      this.emitChanges();
    },
    emitChanges() {
      this.$emit('set-current-bedrooms', null);
      this.$emit('set-current-bathrooms', null);
    },
  },
};
</script>
